import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ClosureSearchGrammar } from '../../grammar/closure-search.grammar';
import { ConfirmationDialogService } from '../../services/confirmation/confirmation-dialog.service';

export interface GrammarRendererModalData {
    grammar: ClosureSearchGrammar;
    flowId?: string;
    context?: Record<string, any>;
    title?: string;
    hasExistingConfiguration?: boolean;
}

export type GrammarRendererModalResult = { action: 'apply'; formData: Record<string, any> } | { action: 'delete' };

@Component({
    selector: 'lib-grammar-renderer-modal',
    templateUrl: './grammar-renderer-modal.component.html',
    styleUrls: ['./grammar-renderer-modal.component.scss'],
    standalone: false,
})
export class GrammarRendererModalComponent implements OnInit {
    public title: string;
    public flowId: string;
    public context: Record<string, any>;
    public hasExistingConfiguration: boolean;

    constructor(
        public dialogRef: MatDialogRef<GrammarRendererModalComponent, GrammarRendererModalResult>,
        @Inject(MAT_DIALOG_DATA) public data: GrammarRendererModalData,
        private confirmationService: ConfirmationDialogService
    ) {
        this.title = data.title || 'Configuration';
        this.flowId = data.flowId || 'setup';
        this.context = data.context || {};
        this.hasExistingConfiguration = !!data.hasExistingConfiguration;
    }

    ngOnInit(): void {}

    public onClose(): void {
        this.dialogRef.close();
    }

    public onApply(formData: Record<string, any>): void {
        this.dialogRef.close({ action: 'apply', formData });
    }

    public onDeleteConfiguration(): void {
        this.confirmationService
            .confirm(
                'Delete Configuration',
                'This will permanently delete the saved Closure Search Configuration for this app. Continue?',
                'Delete',
                'Cancel'
            )
            .subscribe(confirmed => {
                if (confirmed) {
                    this.dialogRef.close({ action: 'delete' });
                }
            });
    }
}
